import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FooterAppComponent } from '../footer-app/footer-app.component';
import { DatosGenerales } from '../../Models/datosGenerales';
import { BannerAppComponent } from '../banner-app/banner-app.component';
import { Observable } from 'rxjs';
import { selectData } from '../../storage/Lead/data.selectors';
import { Store } from '@ngrx/store';
import { getSessionId } from '../../helpers/storageUtils';
import { TrackingService } from '../../services/tracking.service';

@Component({
  selector: 'app-feedback',
  standalone: true,
  templateUrl: './feedback.component.html',
  styleUrl: './feedback.component.scss',
  imports: [
    BannerAppComponent,
    CommonModule,
    FooterAppComponent,
    NgOptimizedImage,
  ],
})
export class FeedbackComponent implements OnInit {
   private trackingService = inject(TrackingService);
  json: string = '';
  jsonFinal: string = '';
  sessionId: string = '';
  completo: string[] = [];

  porcPantalla: string = '';
  msnPantalla: string = '';
  parametro!: string;
  datosGenerales!: DatosGenerales;
  codeAsesor: string | undefined;
  showInitialButtons: boolean;

  generalData: DatosGenerales | null = null;
  generalData$: Observable<DatosGenerales | null>;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store
  ) {
    this.generalData$ = this.store.select(selectData);
    this.showInitialButtons = false;
  }


  ngOnInit(): void {
    this.generalData$.subscribe((data) => {
      this.generalData = data;
      this.showInitialButtons = !this.generalData?.Lead.name;
    })
    this.sessionId = getSessionId().toString();

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.porcPantalla = params.getAll('porcPll')[0];
      this.msnPantalla = params.getAll('msnPll')[0];
      const cliente = params.get('infoAuto');

      if (cliente !== null) {
        this.json = cliente;
        this.jsonFinal = atob(this.json);
        this.datosGenerales = JSON.parse(this.jsonFinal);
        //this.codeAsesor = this.datosPersonales.codAsesor;
        this.parametro = JSON.stringify(this.datosGenerales);
      }
    });

    //this.crearLead();
    this.trackingService.enviarEventoYaTenemosTusDatos('ya_tenemos_tus_datos','Pageview');
  }

  // crearLead() {
  //   this.datosLeads.first_name = this.datosPersonales.cliente.nombreCliente;
  //   this.datosLeads.mobile_phone = this.datosPersonales.cliente.celularCliente;
  //   this.datosLeads.email = this.datosPersonales.cliente.correoCliente;
  //   this.datosLeads.accept_tos = true;
  //   this.datosLeads.assessorCode = this.codeAsesor;

  //   this.leadService.postCrearLeads(this.datosLeads, this.sessionId).
  //     subscribe(
  //       (data) => {
  //         this.resultadoLeads = data
  //         this.GenerarExcepcion(this.resultadoLeads.data.Id, this.msnPantalla, this.porcPantalla);
  //       }
  //     );
  // }

  // GenerarExcepcion(leadId: string, mensaje: string, procentaje: string) {
  //   this.exceptionsServices.addException(this.sessionId, leadId, mensaje, procentaje).
  //     subscribe(
  //       (data) => {
  //         this.exceptionResponse = data;
  //       }
  //     );
  // }

  volverIncio() {
    this.trackingService.enviarEventoYaTenemosTusDatos('ya_tenemos_tus_datos','Button','Volver al Inicio');
    window.location.href = 'https://www.sura.co/';
  }

  irRunt() {
    this.trackingService.enviarEventoYaTenemosTusDatos('ya_tenemos_tus_datos','Button','Volver al Inicio');
    window.location.href = 'https://www.runt.gov.co/';
  }
}
